import React from "react";

/**
 * BTW brand logo. Uses the official badge artwork.
 * - variant="light"  → for dark backgrounds (white + BTW blue)
 * - variant="dark"   → for light backgrounds (black + cyan original)
 */
export const Logo = ({ size = "md", variant = "light", className = "" }) => {
  const sizeMap = {
    sm: "h-9 sm:h-10",
    md: "h-12 sm:h-14",
    lg: "h-20 sm:h-24",
  };
  // Clean square badge (#BTW · Burgers · Tacos · Wings) — no trailing
  // cursive, transparent background, centered for any container.
  const src = "/brand/btw-badge.png";

  return (
    <img
      src={src}
      alt="BTW – Burgers · Tacos · Wings & Seafood"
      data-testid="btw-logo"
      className={`${sizeMap[size]} w-auto select-none ${className}`}
      draggable={false}
    />
  );
};

export default Logo;
